import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { fetchFtpLogs } from 'utils/api/logsApi'
import { getColumns } from './utils'
import { AxiosError } from 'axios'
import { calculateOffset } from 'utils/helpers/pagination'

const FtpLogTable = () => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)

  const { search } = useLocation()
  const { getQuery } = useQuery()

  const columns = useMemo(() => getColumns(page), [page])

  // To get FTP Creation Log data
  const getLogs = async () => {
    try {
      const { data } = await fetchFtpLogs({
        limit: getQuery('limit') || 10,
        page: getQuery('page') || 1,
      })
      setPage(calculateOffset(data))
      setLogResponse(data)
    } catch (error) {
      if (error instanceof AxiosError) {
        setLogResponse({ docs: [] })
      }
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <div className="title">FTP Creation</div>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default FtpLogTable
